export default __webpack_public_path__ + "static/media/ImportRdsLogs.73a018fc.md";